<template>
  <div>
    <top-header></top-header>
    <router-view></router-view>
    <bottom-footer></bottom-footer>
  </div>
</template>
<style>



#refersvg{
  width: 1px;
  height: 1px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -100;
}
</style>
<script>

export default {
  components:{
    
  },
  mounted() {
   
  },
  methods: {
  }

}
</script>